import { physiosPageContent } from "../../data/physiosPageContent";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import "../../styles/physio.css";
import img1 from "../../images/client-todays-plan.png"
import img2 from "../../images/vitaly-gariev-V1K8tniFMQc-unsplash.jpg"
// Patient Experience section
export default function PatientExperience() {
  const currentLang = useCurrentLang();
  const t = physiosPageContent[currentLang]
  const features = [
    {
      title: t.patientExperience.PERKS.t1,
      desc: t.patientExperience.PERKS.desc1,
    },
    {
      title: t.patientExperience.PERKS.t2,
      desc: t.patientExperience.PERKS.desc2,
    },
    {
      title: t.patientExperience.PERKS.t3,
      desc: t.patientExperience.PERKS.desc3,
    },
    {
      title: t.patientExperience.PERKS.t4,
      desc: t.patientExperience.PERKS.desc4,
    },
  ];

  return (
    <section id="patient" className="physio-section physio-patient">
      <div className="glass-card">
        <span className="physio-eyebrow">{t.patientExperience.s}</span>
        <h2>{t.patientExperience.header}</h2>
        <div className="physio-divider" />
        <p className="section-lead">
          {t.patientExperience.desc}
        </p>

        <div className="patient-layout">
          <div>
          <div className="patient-img">
            <img
              src={img2}
              alt="Photo by Vitaly Gariev"
              width="800"
              height="280"
              loading="lazy"
            />
            </div>
            <h1></h1>
            <div className="patient-img">
            <img src={img1} alt="Users Platform Todays Page" 
            width="800"
            height="280"
            loading="lazy"
            />
          </div>
          </div>

          <div className="patient-features">
            {features.map(({ title, desc }, i) => (
              <div className="patient-feat" key={i}>
                <h4>{title}</h4>
                <p>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
